import React from 'react'

import config from '@common/configs'
import useStoreMain, { IMainPropertiesData } from '@store/mainStore'
import { TPaymentMethods } from '@types'

const isUserDeviceMobile = () => {
    const userDevice = navigator.userAgent
    return /iemobile|windows phone|lumia/i.test(userDevice)
        ? 'w'
        : /iPhone|iP[ao]d/.test(userDevice)
        ? 'i'
        : /Android/.test(userDevice)
        ? 'a'
        : /BlackBerry|PlayBook|BB10/.test(userDevice)
        ? 'b'
        : /Mobile Safari/.test(userDevice)
        ? 's'
        : /webos|mobile|tablet|opera mini|\bcrmo\/|opera mobi/i.test(userDevice)
}

const validateWallets = (paymentMethods: string[]) => {
    const isMobile = isUserDeviceMobile()
    const availableWallets = config.wallets
    /*Hack to bypass WalletLinkProvider interface */
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const overrideIsMetaMask = window.ethereum && window.ethereum.overrideIsMetaMask
    const supportedWallets: TPaymentMethods = []
    for (const wallet of availableWallets) {
        wallet.support.includes(isMobile ? 'mobile' : 'web') &&
            (wallet.name !== 'metamask' || !overrideIsMetaMask) &&
            paymentMethods.includes(wallet.name) &&
            supportedWallets.push({ name: wallet.name, type: wallet.type })
    }

    return supportedWallets
}

export default function useMain() {
    const shouldWarning = useStoreMain((state: IMainPropertiesData) => state.shouldWarning)
    const setShouldWarning = useStoreMain((state: IMainPropertiesData) => state.setShouldWarning)
    const currentWallet = useStoreMain((state: IMainPropertiesData) => state.currentWallet)
    const setCurrentWallet = useStoreMain((state: IMainPropertiesData) => state.setCurrentWallet)
    const transactionHash = useStoreMain((state: IMainPropertiesData) => state.transactionHash)
    const setTransactionHash = useStoreMain((state: IMainPropertiesData) => state.setTransactionHash)
    const warningMessage = useStoreMain((state: IMainPropertiesData) => state.warningMessage)
    const setWarningMessage = useStoreMain((state: IMainPropertiesData) => state.setWarningMessage)
    const mainInit = useStoreMain((state: IMainPropertiesData) => state.mainInit)
    const setMainInit = useStoreMain((state: IMainPropertiesData) => state.setMainInit)
    const setMainInitPaymentMethods = useStoreMain((state: IMainPropertiesData) => state.setMainInitPaymentMethods)
    const contract = useStoreMain((state: IMainPropertiesData) => state.contract)
    const setContract = useStoreMain((state: IMainPropertiesData) => state.setContract)
    const currentStep = useStoreMain((state: IMainPropertiesData) => state.currentStep)
    const setCurrentStep = useStoreMain((state: IMainPropertiesData) => state.setCurrentStep)
    const setCurrentSelectedEndpoint = useStoreMain((state: IMainPropertiesData) => state.setCurrentSelectedEndpoint)
    const selectedSalesBehaviour = useStoreMain((state: IMainPropertiesData) => state.selectedSalesBehaviour)
    const setContractSalesPhase = useStoreMain((state: IMainPropertiesData) => state.setContractSalesPhase)
    const setMainInitSalesBehaviourVisible = useStoreMain(
        (state: IMainPropertiesData) => state.setMainInitSalesBehaviourVisible,
    )
    const coupon = useStoreMain((state: IMainPropertiesData) => state.coupon)
    const setCoupon = useStoreMain((state: IMainPropertiesData) => state.setCoupon)
    const reset = useStoreMain((state: IMainPropertiesData) => state.reset)

    const hasMoreThanOneEndpoint = React.useMemo(() => {
        if (!mainInit.salesBehavior) return false
        const hasMoreThanOne = mainInit.salesBehavior.length > 1

        if (!hasMoreThanOne) {
            setContractSalesPhase(mainInit.salesBehavior[0].position)
            setCurrentSelectedEndpoint(mainInit.salesBehavior[0])
        }

        return hasMoreThanOne
    }, [mainInit.salesBehavior])

    return {
        state: {
            shouldWarning,
            currentWallet,
            transactionHash,
            warningMessage,
            mainInit,
            selectedSalesBehaviour,
            contract,
            config,
            currentStep,
            coupon,
            hasMoreThanOneEndpoint,
        },
        operations: {
            setShouldWarning,
            setCoupon,
            setCurrentWallet,
            validateWallets,
            setMainInitPaymentMethods,
            setMainInitSalesBehaviourVisible,
            setTransactionHash,
            setWarningMessage,
            setMainInit,
            setContract,
            setCurrentStep,
            setCurrentSelectedEndpoint,
            setContractSalesPhase,
            reset,
        },
    }
}
